@if(!item.navCap) {
<a
  class="cursor-pointer menuLink"
  (click)="onItemSelected(item)"
  [ngClass]="{
    activeMenu: item.route ? router.isActive(item.route, true) : false
  }"
>
  <ng-container *ngIf="!item.customIcon">
    <i-tabler class="routeIcon icon-18" name="{{ item.iconName }}"></i-tabler>
  </ng-container>
  <ng-container *ngIf="item.customIcon">
    <img *ngIf="options.theme !== 'dark'" [src]="item.customIcon" alt="icon" class="icon-18 align-middle">
    <img *ngIf="options.theme === 'dark' && item.customIconDark" [src]="item.customIconDark" alt="icon" class="icon-18 align-middle">
    <img *ngIf="options.theme === 'dark' && !item.customIconDark" [src]="item.customIcon" alt="icon" class="icon-18 align-middle">
  </ng-container>
  {{ item.displayName | localize }}
  @if(item.children && item.children.length) {
  <span class="down-icon d-flex m-l-auto">
    <mat-icon> expand_more </mat-icon>
  </span>
  }
</a>
} @if(item.children){
<div class="childBox">
  @for(child of item.children; track child) {
  <app-horizontal-nav-item [item]="child" class="ddmenu">
  </app-horizontal-nav-item>
  }
</div>
}
